import React from 'react';
import {miniImagen} from '../requests/utils';
import {Col, Button, Form, FormGroup, Label, FormText} from 'reactstrap';


export default class FrmFotoPerfil extends React.Component{
    constructor(props) {
        super(props);
        this.clickFl = this.clickFl.bind(this);
    }

    clickFl(e){
        document.getElementById('inp_fl').click();
    }

    render(){
        return(       
            <Form>
                <FormGroup className="Frm" row>
                    <Col sm={12} md={12} lg={12} className="frmImg">
                        <Label>Seleccionar la foto de perfil: &nbsp;&nbsp; </Label>
                        <Button color='warning' onClick={(e)=> this.clickFl(e)}>Seleccionar imágen</Button>
                        <input type="file" name="sImagen" id='inp_fl' className="frmPkt inpArchivo Hide_Half" onChange={(e)=> miniImagen(e)}
                        accept="image/x-png,image/jpeg"
                        />
                       
                        <FormText color="muted" id="lblDoc"/>
                    </Col>
                   <Col sm={12} md={12} lg={12}>
                   <span>Max 2 mb.</span>
                   </Col >
                    <Col sm={12} md={12} lg={12} id="prev_Img">
                        <output id="list"></output>
                    </Col>
                </FormGroup>
          </Form>
        )
    };

}



